import { Route, Routes } from 'react-router-dom';
import './App.css';
import NavBar from './Components/NavBar';
import Footer from './Components/Footer';
import AnalyticsTracker from './Components/AnalyticsTracker';
import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Confirmation from './Components/Confirmation';
import OwnerOperator from './Components/OwnerOperator';
import DispatchService from './Components/DispatchService';
import DedicatedLanes from './Components/DedicatedLanes';
import OverTheRoad from './Components/OverTheRoad';
import NotFound from './Components/NotFound';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <div className="site-shell">
      <AnalyticsTracker />
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services/owner-operator" element={<OwnerOperator />} />
        <Route
          path="/services/small-fleet-carrier-dispatch-support"
          element={<DispatchService />}
        />
        <Route
          path="/services/dedicated-lanes-routes"
          element={<DedicatedLanes />}
        />
        <Route
          path="/services/over-the-road"
          element={<OverTheRoad />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
